// 页面类型枚举
const PAGE_TYPES = {
  LIST: 'list',
  ADD: 'add',
  EDIT: 'edit',
  DETAIL: 'detail',
}

// 根据path获取页面类型
function getPageTypeByPath(path) {
  const pathArr = path.split('/')
  const pathArrLength = pathArr.length
  const lastPath = pathArr[pathArrLength - 1] || ''

  let pageType

  if (lastPath.includes('list') || lastPath.includes('List')) {
    pageType = PAGE_TYPES.LIST
  } else if (lastPath.includes('add') || lastPath.includes('Add')) {
    pageType = PAGE_TYPES.ADD
  } else if (lastPath.includes('edit') || lastPath.includes('Edit')) {
    pageType = PAGE_TYPES.EDIT
  } else if (lastPath.includes('detail') || lastPath.includes('Detail')) {
    pageType = PAGE_TYPES.DETAIL
  } else {
    pageType = ''
  }

  return pageType
}

// 列表页传参校验方法
// queryObj结构如下：
// var queryObj = {
//   tab?: value,
//   filter?: {
//     [key]: value
//   },
//   search?: {
//     [key]: value
//   },
//   children?: [
//     {
//       tab?: value,
//       filter?: {
//         [key]: value
//       },
//       search?: {
//         [key]: value
//       }
//     }
//   ]
// };
function validateQuerySchemaForListPage(allQueries, query) {
  query = query ? decodeURIComponent(query) : '{}'

  let isValidatedJson = true
  try {
    query = JSON.parse(query)
  } catch (err) {
    isValidatedJson = false
  }

  // 格式不正确，非json格式
  if (!isValidatedJson || typeof query !== 'object') {
    console.warn('[validateQuerySchemaForListPage]: the type of query is not json string')
    return false
  }

  // 参数没有通过query传递
  if (Object.keys(allQueries).length > 0 && !Object.keys(allQueries).includes('query')) {
    console.warn('[validateQuerySchemaForListPage]: arguments must be passed by query')
    return false
  }

  const TAb_TYPES = ['Number', 'String', 'Undefined']
  const FILTER_TYPES = ['Object', 'Undefined']
  const SEARCH_TYPES = ['Object', 'Undefined']
  const CHILDREN_TYPES = ['Array', 'Undefined']

  // eslint-disable-next-line no-shadow
  function _validate(query) {
    // tab类型不正确
    if (!TAb_TYPES.some((item) => Object.prototype.toString.call(query.tab).includes(item))) {
      console.warn(`[validateQuerySchemaForListPage]: the type of query.tab must in ${TAb_TYPES}`)
      return false
    }
    // filter类型不正确
    if (!FILTER_TYPES.some((item) => Object.prototype.toString.call(query.filter).includes(item))) {
      console.warn(`[validateQuerySchemaForListPage]: the type of query.filter must in ${FILTER_TYPES}`)
      return false
    }
    // search类型不正确
    if (!SEARCH_TYPES.some((item) => Object.prototype.toString.call(query.search).includes(item))) {
      console.warn(`[validateQuerySchemaForListPage]: the type of query.search must in ${SEARCH_TYPES}`)
      return false
    }
    // children类型不正确
    if (!CHILDREN_TYPES.some((item) => Object.prototype.toString.call(query.children).includes(item))) {
      console.warn(`[validateQuerySchemaForListPage]: the type of query.children must in ${CHILDREN_TYPES}`)
      return false
    }
    // 递归校验children
    if (Array.isArray(query.children) && query.children.length > 0 && !query.children.some((child) => _validate(child))) {
      return false
    }
  }

  if (!_validate(query)) return false

  return true
}

// 新建页/编辑页/详情页传参校验方法
// queryObj结构如下：
// var queryObj = {
//   [key]: value
// };
function validateQuerySchemaCommon(allQueries, query) {
  query = query ? decodeURIComponent(query) : '{}'

  let isValidatedJson = true
  try {
    query = JSON.parse(query)
  } catch (err) {
    isValidatedJson = false
  }

  // 格式不正确，非json格式
  if (!isValidatedJson || typeof query !== 'object') {
    console.warn('[validateQuerySchemaCommon]: the type of query is not json string')
    return false
  }

  // 参数没有通过query传递
  if (Object.keys(allQueries).length > 0 && !Object.keys(allQueries).includes('query')) {
    console.warn('[validateQuerySchemaCommon]: arguments must be passed by query')
    return false
  }

  return true
}

export function validateQuerySchema(route) {
  const { path, query: queries } = route
  const { query } = queries
  const pageType = getPageTypeByPath(path)

  if (pageType === PAGE_TYPES.LIST) {
    return validateQuerySchemaForListPage(queries, query)
  } else if (
    pageType === PAGE_TYPES.ADD ||
    pageType === PAGE_TYPES.EDIT ||
    pageType === PAGE_TYPES.DETAIL
  ) {
    return validateQuerySchemaCommon(queries, query)
  }

  return true
}
// 生成json字符串函数
export function genQueryJsonStr(queryObj) {
  return encodeURIComponent(JSON.stringify(queryObj))
}
// 解析json字符串函数
export function parseQueryJsonStr(queryStr) {
  return JSON.parse(decodeURIComponent(queryStr))
}
